"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

require("./tooltip.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Tooltip = function (_Component) {
  _inherits(Tooltip, _Component);

  function Tooltip(props) {
    _classCallCheck(this, Tooltip);

    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));

    _this.closeTooltip = _this.closeTooltip.bind(_this);
    _this.openTooltip = _this.openTooltip.bind(_this);
    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("click", this.closeTooltip);
      window.addEventListener("resize", this.closeTooltip);
      window.addEventListener("touchstart", this.closeTooltip);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("click", this.closeTooltip);
      window.removeEventListener("resize", this.closeTooltip);
    }
  }, {
    key: "closeTooltip",
    value: function closeTooltip(e) {
      if (this.activeTooltip) {
        this.activeTooltip.style.visibility = "hidden";
      }
    }
  }, {
    key: "openTooltip",
    value: function openTooltip(e) {
      //keeps window event from firing and closing the tooltip
      e.stopPropagation();
      var rect = this.tooltipBtn.getBoundingClientRect();
      this.activeTooltip.style.left = rect.x + 10 + "px";
      this.activeTooltip.style.top = rect.y + 10 + "px";
      var bounding = this.activeTooltip.getBoundingClientRect();
      this.fixViewport(bounding);
      this.activeTooltip.style.visibility = "visible";
    }
  }, {
    key: "fixViewport",
    value: function fixViewport(bounding) {
      if (bounding.top < 0) {
        var moveDown = bounding.top - window.innerHeight + 10;
        this.activeTooltip.style.bottom = bounding.bottom - moveDown + "px";
      }

      if (bounding.left < 0) {
        var moveRight = bounding.left - window.innerWidth + 10;
        this.activeTooltip.style.right = bounding.right - moveRight + "px";
      }

      if (bounding.bottom > window.innerHeight) {
        var moveUp = bounding.bottom - window.innerHeight + 10;
        this.activeTooltip.style.top = bounding.top - moveUp + "px";
      }

      if (bounding.right > window.innerWidth) {
        var moveLeft = bounding.right - window.innerWidth + 10;
        this.activeTooltip.style.left = bounding.left - moveLeft + "px";
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          text = _props.text,
          icon = _props.icon;
      return _react2.default.createElement("div", {
        className: "tooltip-parent"
      }, _react2.default.createElement("button", {
        onClick: function onClick(e) {
          return _this2.openTooltip(e);
        },
        className: "pad-0 cur-pointer pos-r",
        ref: function ref(section) {
          _this2.tooltipBtn = section;
        }
      }, _react2.default.createElement("i", {
        className: "material-icons"
      }, icon)), _react2.default.createElement("div", {
        className: "tooltip-text",
        ref: function ref(section) {
          _this2.activeTooltip = section;
        }
      }, text));
    }
  }]);

  return Tooltip;
}(_react.Component);

exports.default = Tooltip;